angular
    .module('tradersyard')
    .factory('analytic-portfolio-factory', [
        function () {
            var factory = {
                me: {},
                init: function (me) {
                    factory.me = me;
                },
                node: function (data, space) {
                    var node = {};
                    if (factory.is.owner(space)) {
                        node = {
                            trade_id: data.trade_id,
                            symbol: data.symbol,
                            entry_reason: data.entry_reason,
                            direction: data.direction,
                            volume: data.volume,
                            entry_price: data.entry_price,
                            decimals: data.decimals,
                            entry_time: data.entry_time,
                            opened_pl: data.opened_profit_loss,
                            closed_pl: data.closed_profit_loss,
                        };
                    } else {
                        node = {
                            trade_id: data.trade_id,
                            symbol: data.symbol,
                            entry_reason: data.entry_reason,
                            direction: data.direction,
                            entry_price: data.entry_price,
                            decimals: data.decimals,
                            entry_time: data.entry_time,
                            opened_pl: data.account_size === 0 ? 0 : data.opened_profit_loss / data.account_size,
                            closed_pl: data.account_size === 0 ? 0 : data.closed_profit_loss / data.account_size,
                        };
                    }

                    return node;
                },
                is: {
                    owner: function (space) {
                        return space === 'me' || space === factory.me.id;
                    },
                },
            };

            return factory;
        },
    ])
    .controller('analytic-portfolio-ctrl', [
        '$scope',
        'graph-analytic-factory',
        'WebSocket',
        'analytic-portfolio-factory',
        '$flex',
        '$location',
        function ($scope, $factory, $broadcast, $portfolio, $flex, $location) {
            const preselectedAccount = parseInt($location.search().account);


            $scope.process = false;
            $scope.params = {
                page: 0,
                limit: 100,
                let: 0,
                ...(preselectedAccount ? { account_id: preselectedAccount } : {}),
            };
            $scope.portfolio = [];
            $scope.space = 'me';
            $scope.listened = false;

            $portfolio.init($scope.$parent.me);

            $scope.init = function ($space) {
                if ($space) $scope.space = $space;

                $scope.find();
            };

            $scope.$entry = function ($space) {
                if ($space) $scope.space = $space;

                $scope.$on('analytic-portfolio-init', function () {
                    $scope.find();
                });

                $scope.$on('analytic-account-select', function (e, id) {
                    $scope.portfolio = [];
                    $broadcast.emit('join:account', [id]);
                    $scope.params = angular.extend($scope.params, {
                        page: 0,
                        let: 0,
                        account_id: id,
                    });
                    $flex.$scroll.renew('portfolio');
                    $scope.find();
                });
            };

            $scope.find = function (next) {
                ++$scope.params.page;
                $factory.portfolio($scope.space, { params: $scope.params }).then(function ($response) {

////
                    if ($response.data.state === 0) {
                        if (!$scope.listened) {
                            $scope.listened = true;
                            $scope.broadcast();
                        }

                        if ($response.data.data.length > 0) {
                            $scope.portfolio = $scope.portfolio.concat($response.data.data);

                            if (next) next();
                        }
                    }

                    $scope.process = true;
                });
            };

            $scope.broadcast = function () {
                $factory.account($scope.space).then(function ($response) {
                    if ($response.data.state === 0) {
                        $broadcast.emit('join:account', [$response.data.data.id]);
                    }
                });
            };

            $broadcast.on('portfolio:create', function (data) {
                for (var i = 0; i < $scope.portfolio.length; i++) {
                    if ($scope.portfolio[i].trade_id === data.node.trade_id) return;
                }

                $scope.portfolio.push($portfolio.node(data.node, $scope.space));
                ++$scope.params.let;
            });

            $broadcast.on('portfolio:update', function (data) {
                for (var i = 0; i < $scope.portfolio.length; i++) {
                    if ($scope.portfolio[i].trade_id === data.node.trade_id) {
                        $scope.portfolio[i] = $portfolio.node(data.node, $scope.space);
                        return;
                    }
                }
            });

            $broadcast.on('portfolio:delete', function (data) {
                for (var i = 0; i < $scope.portfolio.length; i++) {
                    if ($scope.portfolio[i].trade_id === data.node.trade_id) {
                        $scope.portfolio.splice(i, 1);
                        --$scope.params.let;
                        return;
                    }
                }
            });
        },
    ]);
